var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"fixed","top":"0","right":"0","left":"0","bottom":"0"}},[_c('div',{staticStyle:{"padding":"20%","text-align":"center","color":"red"}},[_c('p',[_vm._v("您访问的页面路径错误")]),_vm._v(" "),_c('p',[_vm._v("请重新确认")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03bcf0e6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/routerPages/error.vue
// module id = null
// module chunks = 